import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { destroySlickCarousel, initSlickWhenReady } from '../../Utils/carouselHelpers';
import { mapProjectListItem } from '../../Utils/projectHelpers';
import { getProjects } from '../../Utils/api';
import { HOME_SECTIONS } from '../../i18n/sectionCopy';
import { useLocalizedStatic } from '../../i18n/useLocalizedStatic';
import { useLanguage } from '../../i18n/LanguageContext';
import ProjectCard from './ProjectCard';

const img = (path) => `${process.env.PUBLIC_URL}/assets/images/${path}`;

const PROJECT_SLICK_OPTIONS = {
  autoplay: true,
  autoplaySpeed: 4500,
  pauseOnHover: true,
  infinite: true,
  centerMode: false,
  arrows: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1199, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

const HomeProjectsSection = () => {
  const { locale, revision } = useLanguage();
  const copy = useLocalizedStatic(HOME_SECTIONS);
  const slideRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromApi, setFromApi] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);

    getProjects()
      .then((data) => {
        if (!active) return;
        setProjects((data || []).map(mapProjectListItem).slice(0, 8));
        setFromApi(true);
      })
      .catch((err) => {
        if (!active) return;
        console.warn('Failed to load home projects:', err?.message || err);
        setProjects([]);
        setFromApi(false);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [locale, revision]);

  useLayoutEffect(() => {
    const el = slideRef.current;
    return () => destroySlickCarousel(el);
  }, []);

  useLayoutEffect(() => {
    if (loading || projects.length < 2) return undefined;

    const el = slideRef.current;
    destroySlickCarousel(el);
    return initSlickWhenReady(el, PROJECT_SLICK_OPTIONS);
  }, [loading, projects]);

  return (
    <div className="rs-project project-style1 gray-bg pt-120 pb-120 md-pt-80 md-pb-80">
      <div className="container">
        <div className="sec-title text-center mb-45">
          <span className="sub-text">
            <img src={img('shape-1.png')} alt="Images" />
            {copy.projectsSub}
          </span>
          <h2 className="title">{copy.projectsTitle}</h2>
        </div>

        {loading && (
          <p className="text-center py-4 home-projects-loading">{copy.projectsLoading}</p>
        )}

        {!loading && fromApi && projects.length === 0 && (
          <p className="text-center py-4 home-projects-empty">{copy.projectsEmpty}</p>
        )}

        {!loading && !fromApi && (
          <p className="text-center py-4 text-danger home-projects-error">{copy.projectsLoadError}</p>
        )}

        {!loading && projects.length > 0 && (
          <div className="project-slider-wrap">
            <div className="project-slide-1 slider" ref={slideRef}>
              {projects.map((item) => (
                <div key={item.id} className="project-slide-item">
                  <ProjectCard item={item} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeProjectsSection;
